<template>
  <multiselect
      v-if="hasOptions"
      class="due-date-type-select"
      :options="dueDateTypes.options"
      v-model="selectedType"
      :hide-selected="false"
      :preselectFirst="true"
      :showLabels="false"
      :group-select="false"
      selectLabel=""
      placeholder=""
      tagPlaceholder=" "
      deselectLabel=""
      :searchable="false"
      label="name"
      track-by="value"
  >
    <template #caret="{ toggle }">
      <caret-icon @mousedown.prevent.stop="toggle" :solid="solid" :hide="!hasOptions" />
    </template>

    <template slot="singleLabel" slot-scope="props">
            <span class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
            </span>
    </template>

    <template slot="option" slot-scope="props">
      <div class="option__desc">
        <span class="option__title">{{ props.option.name }}</span>
      </div>
    </template>
  </multiselect>
</template>

<script>
import DueDateType from '@/services/Property/DueDateType';
import { mapGetters, mapActions } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  props: {
    solid: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dueDateTypes: {
        options: {},
      },
    };
  },

  async mounted() {
    await this.getDueDateTypes();

    if (this.$route.query.dueDateType !== undefined) {
      this.setDueDateType(this.$route.query.dueDateType);

      // eslint-disable-next-line
      history.pushState({}, null, `${this.$route.path}`);
    } else if (!this.$store.getters.dueDateType && this.hasOptions) {
      // Set a default value
      this.setDueDateType(this.defaultType);
    }
  },

  computed: {
    defaultType() {
      return this.hasOptions
        ? this.dueDateTypes.options.find(el => el.value === 'programDueDate')
        : null;
    },
    selectedType: {
      get() {
        return this.$store.getters.dueDateType || this.defaultType;
      },
      set(value) {
        this.setDueDateType(value);
      },
    },

    hasOptions() {
      return this.dueDateTypes.options && !isEmpty(this.dueDateTypes.options);
    },
  },

  methods: {
    ...mapActions(['setDueDateType']),
    async getDueDateTypes() {
      const { data } = await DueDateType.list();
      this.dueDateTypes.options = data.data || [];
    },
  },
};
</script>

<style lang="scss">
.compliance-type-select {
  margin-right: 5px;
  height: 33px;
  min-height: 33px;

  .multiselect_ {
    &_tags {
      border: none;
      background-color: unset;
      font-weight: bold;
      padding-left: 0;
      padding-top: 0;
      min-height: 28px;
      padding-right: 15px;
      min-width: 118px;

      .option__desc {
        margin-left: 8px;
      }
    }

    &_single {
      padding: 0;
      margin: 0;
      background-color: unset;

      .option__title {
        line-height: 34px;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
      }
    }

    &_option {
      &:hover {
        background: #F7F9FA;
      }
      &--highlight {
        background: $white;
        color: $black;
      }
    }

    &_caret {
      top: 8px;
      right: 0;
    }

    &_content-wrapper {
      top: 42px;
      max-height: fit-content;
      padding: 0.5rem 0;
      margin: 0.125rem 0 0;
      font-size: 1rem;
      color: #4E738A;
      text-align: left;
      list-style: none;
      background-color: #ffffff;
      background-clip: padding-box;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 0.25rem;

      .option__desc {
        display: inline-block;
        margin-left: 10px;
      }
    }
  }
}

.spacer {
  position: relative;
  top: 13px;
  height: 15px;
  width: 2px;
  margin: 0 22px;
  background: #000;
}

@media screen and (max-width: 767px) {
  .compliance-type-select {
    max-width: 40px;
  }
}

@media screen and (max-width: 1024px) {
  .compliance-type-select {
    .multiselect_ {
      &_tags {
        height: 28px;
        padding-right: 0;
      }

      &_single {
        .option__desc {
          .option__title {
            display: none;
          }
        }
      }

      &_caret {
        left: 50px;
      }

      &_content-wrapper {
        top: 39px;
      }
    }
  }

  .spacer {
    margin: 0;
  }

  .sub-nav /deep/ {
    .nav-items {
      max-width: 90vw !important;
      width: 100%;

      &.has-actions {
        max-width: calc(82vw - 105px) !important;
      }
    }
  }
}

.due-date-type-select {
  .multiselect__single {
    line-height: 28px;
    margin-bottom: 0;
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background: #f3f3f3;
    color: #000;
  }
}
</style>
